var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticClass:"view m-t--15"},[_c('b-col',{staticClass:"p-0 d-lg-none",attrs:{"cols":"12"}},[_c('mobile')],1),_c('b-col',{attrs:{"cols":"12","xl":"11"}},[_c('last-searchs')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }